import * as React from "react"
import * as styles from "./styles.module.scss"
import { brand } from "config/brand"
import letter540w from "./images/letter-square-540w.jpg"
import letter1080w from "./images/letter-square-1080w.jpg"

const ContactUs: React.FC = () => {
  return (
    <section className={styles.contactUs}>
      <div className={styles.pagePadding}>
        <div className={styles.figureWrapper}>
          <figure className={styles.figure}>
            <img
              className={styles.image}
              src={letter540w}
              srcSet={`${letter540w} 540w, ${letter1080w} 1080w`}
              alt="Letter"
              sizes="40vw"
            />
          </figure>
        </div>
        <div className={styles.message}>
          <div className={styles.header}>
            <h2 className={styles.heading}>Contact us</h2>
          </div>
          <div
            className={styles.sections}
            vocab="https://schema.org/"
            typeof="Corporation"
          >
            <div className={styles.section}>
              <h3 className={styles.sectionHeading}>General inquiries</h3>
              <p className={styles.sectionSubhead}>
                We're available by phone or email:
              </p>
              <p className={styles.sectionContactDetail}>
                <a
                  className={styles.link}
                  href={`tel:${brand.phone}`}
                  property="telephone"
                >
                  {brand.phone}
                </a>
                <small className={styles.phoneDisclaimer}>
                  Not for use by New York borrowers
                </small>
              </p>
              <p className={styles.sectionContactDetail}>
                <a
                  className={styles.link}
                  href="mailto:hello@better.com"
                  property="email"
                >
                  hello@better.com
                </a>
              </p>
            </div>
            <div className={styles.section}>
              <h3 className={styles.sectionHeading}>Press inquiries</h3>
              <p className={styles.sectionContactName}>Tanya Hayre</p>
              <p className={styles.sectionContactDetail}>
                <a className={styles.link} href="mailto:thayre@better.com">
                  thayre@better.com
                </a>
              </p>
            </div>
            <div className={styles.section}>
              <h3 className={styles.sectionHeading}>Complaints</h3>
              <p className={styles.sectionContactDetail}>
                <a className={styles.link} href="mailto:complaints@better.com">
                  complaints@better.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactUs
